<template>
  <div class="stars">
    <img src="../../assets/imgs/music-notes/stars-01.png" ref="stars01" class="stars-01" />
    <img src="../../assets/imgs/music-notes/stars-02.png" ref="stars02" class="stars-02" />
    <img src="../../assets/imgs/music-notes/stars-02.png" ref="stars04" class="stars-04" />
    <img src="../../assets/imgs/music-notes/stars-03.png" ref="stars03" class="stars-03" />
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: "Stars",
  data() {
    return {
      lang: []
    }
  },
  props: {
    showStars: {
      type: String,
      default: ''
    },
  },
  mounted() {
    this.startStars();
    if(this.showStars == 'one') {
      this.startStars();
    } else {
      this.startStarsTwo();
    }

  },
	methods: {
		startStars() {
      var stars4 = gsap.timeline({repeat: -1});
      stars4.set(this.$refs.stars04, { opacity: 0, x: 0, y: 0});

      var stars1 = gsap.timeline({repeat: -1});
      stars1.set(this.$refs.stars01, { x: 0, y: 0});
      stars1.to(this.$refs.stars01, { x: 5, y: 5, duration: 1, ease: "power2.out"});      
      stars1.to(this.$refs.stars01, { x: 2, y: 8, duration: 1, ease: "power2.in"});      

      var stars2 = gsap.timeline({repeat: -1});
      stars2.set(this.$refs.stars02, { x: 25, y: 0});
      stars2.to(this.$refs.stars02, { x: 25, y: 2, rotate: 25, opacity: 1, duration: 1, ease: "power2.in"});      
      stars2.to(this.$refs.stars02, { x: 23, y: 0, duration: 1, ease: "power2.out"});      

      var stars3 = gsap.timeline({repeat: -1});
      stars3.set(this.$refs.stars03, { x: -140, y: 70});
      stars3.to(this.$refs.stars03, { x: -136, y: 72, duration: 1, ease: "power2.in"});      
      stars3.to(this.$refs.stars03, { x: -144, y: 74, duration: 1, ease: "power2.out"});      
		},
    startStarsTwo() {
      var stars1 = gsap.timeline({repeat: -1});
      stars1.set(this.$refs.stars01, { x: 0, y: 0});
      stars1.to(this.$refs.stars01, { x: 5, y: 5, rotate: 5, duration: 2, ease: "power2.out"});      
      stars1.to(this.$refs.stars01, { x: 2, y: 8, rotate: 15, duration: 1, ease: "power2.in"});      
      stars1.to(this.$refs.stars01, { x: 2, y: 8, rotate: 5, duration: 1, ease: "power2.in"});      

      var stars2 = gsap.timeline({repeat: -1});
      stars2.set(this.$refs.stars02, { x: 25, y: 0});
      stars2.to(this.$refs.stars02, { x: 25, y: 2, rotate: 15, opacity: 1, duration: 1.2, ease: "power2.in"});      
      stars2.to(this.$refs.stars02, { x: 23, y: 0, rotate: 5, duration: 1, ease: "power2.out"});      

      var stars4 = gsap.timeline({repeat: -1});
      stars4.set(this.$refs.stars04, { x: -155, y: -70, opacity: 1});
      stars4.to(this.$refs.stars04, { x: -155, y: -66, rotate: 20, opacity: 1, duration: 2, ease: "power2.in"});      
      stars4.to(this.$refs.stars04, { x: -153, y: -70, duration: 1, ease: "power2.out"});      

      var stars3 = gsap.timeline({repeat: -1});
      stars3.set(this.$refs.stars03, { x: -100, y: -120});
      stars3.to(this.$refs.stars03, { x: -106, y: -122, duration: 1.8, ease: "power2.in"});      
      stars3.to(this.$refs.stars03, { x: -104, y: -124, duration: 1, ease: "power2.out"});      
		} 
	}
}
</script>
<style scoped lang="scss">
.stars {
  .stars-01 {
    transform: translate(0, 0);
  }
  .stars-02 {
    transform: translate(0, 0);
  }
  .stars-03 {
    transform: translate(0, 0);
  }
}
</style>
